// Home page layout variants
import ClassicLayout from './ClassicLayout';
import ModernLayout from './ModernLayout';
import MinimalistLayout from './MinimalistLayout';

// Map layout names to components
export const layoutMap = {
  classic: ClassicLayout,
  modern: ModernLayout,
  minimalist: MinimalistLayout
};

// Default layout
export default ClassicLayout;
